// src/components/shared/AuthPageShell.js
import React from 'react';
import logo from '../../images/logo.png';

const AuthPageShell = ({ title, children }) => (
  <div className="login-page bk-img">
    <div className="form-content">
      <div className="container">
        <div className="row d-flex align-items-center justify-content-center vh-100">
          <div className="col-md-6 login-box">
            <h1 className="text-center pt-2x">
              <img src={logo} width="150" alt="Logo" />
            </h1>
            <h1 className="text-center text-bold">{title}</h1>
            <div className="well row pt-2x pb-3x bk-light">
              <div className="col-md-8 offset-md-2">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AuthPageShell;
